import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=5a9476f3&scoped=true"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"
import style0 from "./Course.vue?vue&type=style&index=0&id=5a9476f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a9476f3",
  null
  
)

export default component.exports